import React, { useEffect, useState } from "react";
import { fetchReportInteractions } from "../../../services/httpClient";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface InteractionsStaleTableState {
  data?: any[];
}

export const InteractionsStaleTable = ({ data }: InteractionsStaleTableState): React.JSX.Element | null => {
  const [tableData, setTableData] = useState<any[]>();

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Name", key: "creator_name" },
    { label: "Most Recent Interaction", key: "most_recent_date" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        setTableData(data);
      } else {
        await getInteractions();
      }
    };

    fetchData();
  }, [data]);

  const getInteractions = async () => {
    fetchReportInteractions()
      .then(async (res: any) => {
        const data = res[0].data || {};
        setTableData(data.stale_cases);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return tableData ? (
    <DataTable tableHeadings={tableHeaders} tableData={tableData} title={"No Case Interactions in Past Week"} />
  ) : (
    loadingCard()
  );
};
